import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const OurPurpose = Loadable(lazy(() => import('../views/our-purpose/OurPurpose')))
// const CurrentProgress = Loadable(lazy(() => import('../views/current-progress/CurrentProgress')))
const ImportantInfo = Loadable(lazy(() => import('../views/important-info/ImportantInfo')))
const Safety = Loadable(lazy(() => import('../views/important-info/Safety')))
const PrivacyTerms = Loadable(lazy(() => import('../views/important-info/PrivacyTerms')))
// const TestingFeedback = Loadable(lazy(() => import('../views/feedback/TestingFeedback')))
// const Wall = Loadable(lazy(() => import('../views/wall/Wall')))
const UserJourney = Loadable(lazy(() => import('../views/user-journey/UserJourney')))
// const TypographyPage = Loadable(lazy(() => import('../views/utilities/TypographyPage')))
// const Shadow = Loadable(lazy(() => import('../views/utilities/Shadow')))
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/UnderMaintenance')));
const Register = Loadable(lazy(() => import('../views/authentication/Register')));
const Logout = Loadable(lazy(() => import('../views/authentication/Logout')));
const Login = Loadable(lazy(() => import('../views/authentication/Login')));
const ForgottenPassword = Loadable(lazy(() => import('../views/authentication/auth/ForgottenPassword')));
const ResetPassword = Loadable(lazy(() => import('../views/authentication/auth/ResetPassword')));
const Account = Loadable(lazy(() => import('../views/authentication/Account')));
const VerifyEmail = Loadable(lazy(() => import('../views/authentication/auth/VerifyEmail')));
const LoginSession = Loadable(lazy(() => import('../views/authentication/LoginSession')));
const NewSession = Loadable(lazy(() => import('../views/authentication/NewSession')));
const Settings = Loadable(lazy(() => import('../views/authentication/Settings')));
const Contact = Loadable(lazy(() => import('../views/contact/Contact')));
const Crisis = Loadable(lazy(() => import('../views/crisis/Crisis')));
const ZosaComponent = Loadable(lazy(() => import('../views/zosa/ZosaApp')));
const Programs = Loadable(lazy(() => import('../views/programs/Programs')));
const VirtualPet = Loadable(lazy(() => import('../views/virtual-pet/VirtualPet')));
const DeleteAccount = Loadable(lazy(() => import('../views/authentication/auth/DeleteAccount')));
const Membership = Loadable(lazy(() => import('../views/authentication/Membership')));
const ActionConfirm = Loadable(lazy(() => import('../views/authentication/ActionConfirm')));
const DeepDive = Loadable(lazy(() => import('../views/deep-dives/DeepDive')));
const SeedPhraseEncrypted = Loadable(lazy(() => import('../views/encryption/EncryptedSeedPhraseGenerator')));
const ZoSecureInfo = Loadable(lazy(() => import('../views/encryption/ZoSecureInfo')));
const ScheduledAppointments = Loadable(lazy(() => import('../views/dashboard/components/zosa-components/ScheduledAppointments')));
const Analysis = Loadable(lazy(() => import('../views/analysis/CharacterAnalysisPage')));
const ZosaTalk = Loadable(lazy(() => import('../views/zosa-talk/ZosaTalk')));
const Onboarding = Loadable(lazy(() => import('../views/authentication/auth/onboarding/Onboarding')));
const Community = Loadable(lazy(() => import('../views/community/CommunityTopics')));
const Notes = Loadable(lazy(() => import('../views/dashboard/components/zosa-components/Notes')));
const Tools = Loadable(lazy(() => import('../views/dashboard/components/zosa-components/Tools')));
const ZosaForBusiness = Loadable(lazy(() => import('../views/business/ZosaForBusiness')));
const BusinessInsights = Loadable(lazy(() => import('../views/business/BusinessInsights')));
const MindGraph = Loadable(lazy(() => import('../views/mind-graph/MindGraph')));
const Admin = Loadable(lazy(() => import('../views/admin/admin')));
const B2BPortal = Loadable(lazy(() => import('../views/b2b/B2BPortal')));
const SnapshotIntake = Loadable(lazy(() => import('../views/trading/SnapshotIntake')));
const TradingDashboard = Loadable(lazy(() => import('../views/trading/TradingDashboard')));
const NdInfo = Loadable(lazy(() => import('../views/nd-info/NdInfo')));
const UnderstandingZosa = Loadable(lazy(() => import('../views/content/UnderstandingZosa')));
const PathwayOnboarding = Loadable(lazy(() => import('../views/pathway/PathwayOnboarding')));
const PathwayReview = Loadable(lazy(() => import('../views/pathway/PathwayReview')));
const PartnerDashboard = Loadable(lazy(() => import('../views/business/PartnerDashboard')));
const ZosaReviews = Loadable(lazy(() => import('../views/content/ZosaReviews')));
// const Wall = Loadable(lazy(() => import('../views/wall/Wall')));

//SEO Pages
const ZosaDescription = Loadable(lazy(() => import('../views/content/ZosaDescription')));
const ZosaAI = Loadable(lazy(() => import('../views/content/ZosaAI')));
const AiMentalHealth = Loadable(lazy(() => import('../views/content/AiMentalHealth')));
const AiTherapy = Loadable(lazy(() => import('../views/content/AiTherapy')));
const ZosaAppContent = Loadable(lazy(() => import('../views/content/ZosaAppContent')));
const AiTherapist = Loadable(lazy(() => import('../views/content/AiTherapist')));
const TherapyChatbot = Loadable(lazy(() => import('../views/content/TherapyChatbot')));
const AiMentalHealthCompanion = Loadable(lazy(() => import('../views/content/AiMentalHealthCompanion')));
const VirtualTherapist = Loadable(lazy(() => import('../views/content/VirtualTherapist')));
const AnonymousTherapy = Loadable(lazy(() => import('../views/content/AnonymousTherapy')));
const AnonymousAIChatbot = Loadable(lazy(() => import('../views/content/AnonymousAIChatbot')));
const AnonymousAITherapy = Loadable(lazy(() => import('../views/content/AnonymousAITherapy')));
const PersonalisedTherapy = Loadable(lazy(() => import('../views/content/PersonalisedTherapy')));
const MentalHealthSupport = Loadable(lazy(() => import('../views/content/MentalHealthSupport')));
const OnlineTherapy = Loadable(lazy(() => import('../views/content/OnlineTherapy')));
const EncryptedTherapy = Loadable(lazy(() => import('../views/content/EncryptedTherapy')));
const SecureMentalHealthPlatform = Loadable(lazy(() => import('../views/content/SecureMentalHealthPlatform')));
const MentalWellBeing = Loadable(lazy(() => import('../views/content/MentalWellBeing')));
const FAQ = Loadable(lazy(() => import('../views/content/FAQ')));
const FreeAiTherapyChatbot = Loadable(lazy(() => import('../views/content/FreeAiTherapyChatbot')));
const BestFreeAiTherapyBots = Loadable(lazy(() => import('../views/content/BestFreeAiTherapyBots')));
const ExploreFreeAiTherapyApps = Loadable(lazy(() => import('../views/content/ExploreFreeAiTherapyApps')));
const ProsAndConsOfAiTherapy = Loadable(lazy(() => import('../views/content/ProsAndConsOfAiTherapy')));
const IsAiTherapyHelpful = Loadable(lazy(() => import('../views/content/IsAiTherapyHelpful')));
const AiTherapyApps = Loadable(lazy(() => import('../views/content/AiTherapyApps')));
const UsingAiForCbt = Loadable(lazy(() => import('../views/content/UsingAiForCbt')));
const UsingAiForCbtAndDbt = Loadable(lazy(() => import('../views/content/UsingAiForCbtAndDbt')));
const WhichAiChatbotIsBest = Loadable(lazy(() => import('../views/content/WhichAiChatbotIsBest')));
const TopAiChatbotsForMentalHealth = Loadable(lazy(() => import('../views/content/TopAiChatbotsForMentalHealth')));
const WhatIsAnAiTherapist = Loadable(lazy(() => import('../views/content/WhatIsAnAiTherapist')));
const OvercomingStigmaAiMentalHealth = Loadable(lazy(() => import('../views/content/OvercomingStigmaAiMentalHealth')));
const TheScienceBehindAiTherapy = Loadable(lazy(() => import('../views/content/TheScienceBehindAiTherapy')));
const BestAiTherapy = Loadable(lazy(() => import('../views/content/BestAiTherapy')));
const BestAiTherapist = Loadable(lazy(() => import('../views/content/BestAiTherapist')));
const BestAiTherapyApp = Loadable(lazy(() => import('../views/content/BestAiTherapyApp')));
const IsMyProblemSeriousEnough = Loadable(lazy(() => import('../views/content/IsMyProblemSeriousEnough')));
const WhyJournallingDoesNotWork = Loadable(lazy(() => import('../views/content/WhyJournallingDoesNotWork')));
const ChatGptForMentalHealth = Loadable(lazy(() => import('../views/content/ChatGptForMentalHealth')));
const CantAffordTherapy = Loadable(lazy(() => import('../views/content/CantAffordTherapy')));
const HowToTrackYourMentalHealth = Loadable(lazy(() => import('../views/content/HowToTrackYourMentalHealth')));
const BetweenTherapySessions = Loadable(lazy(() => import('../views/content/BetweenTherapySessions')));
const WhyYouCantSeeYourOwnPatterns = Loadable(lazy(() => import('../views/content/WhyYouCantSeeYourOwnPatterns')));
const AiBenefitsForEmployees = Loadable(lazy(() => import('../views/content/AiBenefitsForEmployees')));
const EapAlternative = Loadable(lazy(() => import('../views/content/EapAlternative')));
const CostOfEmployeeBurnout = Loadable(lazy(() => import('../views/content/CostOfEmployeeBurnout')));
const EmployeeMentalHealthBenefitCost = Loadable(lazy(() => import('../views/content/EmployeeMentalHealthBenefitCost')));
const HowToChooseEmployeeMentalHealthBenefit = Loadable(lazy(() => import('../views/content/HowToChooseEmployeeMentalHealthBenefit')));

// Guides hub, and the 5 new SEO pages added alongside it
const GuidesHub = Loadable(lazy(() => import('../views/content/GuidesHub')));
const ZosaVsBetterHelpAndTalkspace = Loadable(lazy(() => import('../views/content/ZosaVsBetterHelpAndTalkspace')));
const AiCompanionForLoneliness = Loadable(lazy(() => import('../views/content/AiCompanionForLoneliness')));
const IsItSafeToTalkToAnAiAboutYourMentalHealth = Loadable(lazy(() => import('../views/content/IsItSafeToTalkToAnAiAboutYourMentalHealth')));
const SignsOfBurnout = Loadable(lazy(() => import('../views/content/SignsOfBurnout')));
const AiSupportForAdhdAndRsd = Loadable(lazy(() => import('../views/content/AiSupportForAdhdAndRsd')));

// Mental fitness / performance angle: 5 more SEO pages
const MentalFitnessTracker = Loadable(lazy(() => import('../views/content/MentalFitnessTracker')));
const MentalHealthCompetitiveEdge = Loadable(lazy(() => import('../views/content/MentalHealthCompetitiveEdge')));
const MentalRepsBuildingResilience = Loadable(lazy(() => import('../views/content/MentalRepsBuildingResilience')));
const TrackYourMentalStateLikeHrv = Loadable(lazy(() => import('../views/content/TrackYourMentalStateLikeHrv')));
const MentalHealthForHighPerformers = Loadable(lazy(() => import('../views/content/MentalHealthForHighPerformers')));


const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/dashboard', exact: true, element: <Navigate to="/" /> },
      { path: '/home', exact: true, element: <Navigate to="/" /> },
      { path: '/our-purpose', exact: true, element: <OurPurpose /> },
      { path: '/important-info', exact: true, element: <ImportantInfo /> },
      { path: '/safety', exact: true, element: <Safety /> },
      { path: '/privacy', exact: true, element: <PrivacyTerms /> },
      { path: '/terms', exact: true, element: <PrivacyTerms /> },
      { path: '/welcome', element: <LoginSession /> },
      { path: '/new-session', element: <NewSession /> },
      { path: '/journey', element: <UserJourney /> },
      { path: '/', element: <ZosaComponent /> },
      { path: '/logout', element: <Logout /> },
      { path: '/account', element: <Account /> },
      { path: '/settings', element: <Settings /> },
      { path: '/crisis', element: <Crisis /> },
      { path: '/zosecure', element: <ZoSecureInfo /> },
      { path: '/programs', element: <Programs /> },
      { path: '/contact', element: <Contact /> },
      { path: '/zoki', element: <VirtualPet /> },
      { path: '/talk', element: <ZosaTalk /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: '/delete-account', element: <DeleteAccount /> },
      { path: '/membership', element: <Membership /> },
      { path: '/explore', element: <DeepDive /> },
      { path: '/appointments', element: <ScheduledAppointments /> },
       // { path: '/current-progress', exact: true, element: <CurrentProgress /> },
      // { path: '/feedback', exact: true, element: <TestingFeedback /> },
      // { path: '/ui/typography', exact: true, element: <TypographyPage /> },
      // { path: '/ui/shadow', exact: true, element: <Shadow /> },
      // { path: '/voidboard', element: <Wall /> },
      { path: '/analysis', element: <Analysis /> },
      { path: '/community', element: <Community /> },
      { path: '/notes', element: <Notes /> },
      { path: '/tools', element: <Tools /> },
      { path: '/zosa-at-work', element: <ZosaForBusiness /> },
      { path: '/business', element: <Navigate to="/zosa-at-work" replace /> },
      { path: '/business-insights', element: <BusinessInsights /> },
      { path: '/mind-graph', element: <MindGraph /> },
      { path: '/admin', element: <Admin /> },
      { path: '/b2b', element: <B2BPortal /> },
      { path: '/aCr1WUq7JZch', element: <SnapshotIntake /> },
      { path: '/2CwfeVhT1bIh', element: <TradingDashboard /> },
      { path: '/nd-info', element: <NdInfo /> },
      { path: '/understanding-zosa', element: <UnderstandingZosa /> },
      { path: '/pathway/review', element: <PathwayReview /> },
      { path: '/partners', element: <PartnerDashboard /> },
      { path: '/reviews', element: <ZosaReviews /> },




      //SEO Pages
      { path: '/zosa', element: <ZosaDescription /> },
      { path: '/zosa-ai', element: <ZosaAI /> },
      { path: '/ai-mental-health', element: <AiMentalHealth /> },
      { path: '/ai-therapy', element: <AiTherapy /> },
      { path: '/zosa-app', element: <ZosaAppContent /> },
      { path: '/ai-therapist', element: <AiTherapist /> },
      { path: '/therapy-chatbot', element: <TherapyChatbot /> },
      { path: '/ai-mental-health-companion', element: <AiMentalHealthCompanion /> },
      { path: '/virtual-therapist', element: <VirtualTherapist /> },
      { path: '/anonymous-therapy', element: <AnonymousTherapy /> },
      { path: '/anonymous-ai-chatbot', element: <AnonymousAIChatbot /> },
      { path: '/anonymous-ai-therapy', element: <AnonymousAITherapy /> },
      { path: '/personalised-therapy', element: <PersonalisedTherapy /> },
      { path: '/mental-health-support', element: <MentalHealthSupport /> },
      { path: '/online-therapy', element: <OnlineTherapy /> },
      { path: '/encrypted-therapy', element: <EncryptedTherapy /> },
      { path: '/secure-mental-health-platform', element: <SecureMentalHealthPlatform /> },
      { path: '/mental-well-being', element: <MentalWellBeing /> },
      { path: '/faqs', element: <FAQ /> },
      { path: '/free-ai-therapy-chatbot', element: <FreeAiTherapyChatbot /> },
      { path: '/best-free-ai-therapy-bots', element: <BestFreeAiTherapyBots /> },
      { path: '/explore-free-ai-therapy-apps', element: <ExploreFreeAiTherapyApps /> },
      { path: '/pros-and-cons-of-ai-therapy', element: <ProsAndConsOfAiTherapy /> },
      { path: '/is-ai-therapy-helpful', element: <IsAiTherapyHelpful /> },
      { path: '/ai-therapy-apps', element: <AiTherapyApps /> },
      { path: '/using-ai-for-cbt', element: <UsingAiForCbt /> },
      { path: '/using-ai-for-cbt-and-dbt', element: <UsingAiForCbtAndDbt /> },
      { path: '/which-ai-chatbot-is-best', element: <WhichAiChatbotIsBest /> },
      { path: '/top-ai-chatbots-for-mental-health', element: <TopAiChatbotsForMentalHealth /> },
      { path: '/what-is-an-ai-therapist', element: <WhatIsAnAiTherapist /> },
      { path: '/overcoming-stigma-ai-mental-health', element: <OvercomingStigmaAiMentalHealth /> },
      { path: '/the-science-behind-ai-therapy', element: <TheScienceBehindAiTherapy /> },
      { path: '/best-ai-therapy', element: <BestAiTherapy /> },
      { path: '/best-ai-therapist', element: <BestAiTherapist /> },
      { path: '/best-ai-therapy-app', element: <BestAiTherapyApp /> },
      { path: '/is-my-problem-serious-enough', element: <IsMyProblemSeriousEnough /> },
      { path: '/why-journalling-does-not-work', element: <WhyJournallingDoesNotWork /> },
      { path: '/chatgpt-for-mental-health', element: <ChatGptForMentalHealth /> },
      { path: '/cant-afford-therapy', element: <CantAffordTherapy /> },
      { path: '/how-to-track-your-mental-health', element: <HowToTrackYourMentalHealth /> },
      { path: '/between-therapy-sessions', element: <BetweenTherapySessions /> },
      { path: '/why-you-cant-see-your-own-patterns', element: <WhyYouCantSeeYourOwnPatterns /> },
      { path: '/ai-benefits-for-employees', element: <AiBenefitsForEmployees /> },
      { path: '/eap-alternative', element: <EapAlternative /> },
      { path: '/cost-of-employee-burnout', element: <CostOfEmployeeBurnout /> },
      { path: '/employee-mental-health-benefit-cost', element: <EmployeeMentalHealthBenefitCost /> },
      { path: '/how-to-choose-employee-mental-health-benefit', element: <HowToChooseEmployeeMentalHealthBenefit /> },
      { path: '/guides', element: <GuidesHub /> },
      { path: '/zosa-vs-betterhelp-and-talkspace', element: <ZosaVsBetterHelpAndTalkspace /> },
      { path: '/ai-companion-for-loneliness', element: <AiCompanionForLoneliness /> },
      { path: '/is-it-safe-to-talk-to-an-ai-about-your-mental-health', element: <IsItSafeToTalkToAnAiAboutYourMentalHealth /> },
      { path: '/signs-of-burnout', element: <SignsOfBurnout /> },
      { path: '/ai-support-for-adhd-and-rsd', element: <AiSupportForAdhdAndRsd /> },
      { path: '/mental-fitness-tracker', element: <MentalFitnessTracker /> },
      { path: '/mental-health-competitive-edge', element: <MentalHealthCompetitiveEdge /> },
      { path: '/mental-reps-building-resilience', element: <MentalRepsBuildingResilience /> },
      { path: '/track-your-mental-state-like-hrv', element: <TrackYourMentalStateLikeHrv /> },
      { path: '/mental-health-for-high-performers', element: <MentalHealthForHighPerformers /> },


    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: 'maintenance', element: <Maintenance /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/forgot-password', element: <ForgottenPassword /> },
      { path: '/auth/reset-password', element: <ResetPassword /> },
      { path: '/auth/confirm', element: <ActionConfirm /> },
      // { path: '*', element: <Navigate to="/auth/404" /> },
    ]
  },
  // { path: '/seed-phrase', element: <SeedPhraseGenerator /> },
  { path: '/pathway', element: <PathwayOnboarding /> },
  { path: '/seed', element: <SeedPhraseEncrypted /> },
  { path: '/verify-email', element: <VerifyEmail /> },
  { path: '/getting-started', element: <Onboarding /> },
];

export default Router;
